import * as React from 'react';
import { useState } from 'react';
import { getApi } from '../api/api';
import { ApiSpace } from '../api/ApiTypes';
import { SpaceLink } from '../components/station/SpaceBox';

type AdminInstanceEntry = {
    name: string;
    link: string;
    space?: ApiSpace;
};

const AdminInstanceEntry: React.FC<{ instance: AdminInstanceEntry }> = ({ instance }) => {
    const { space } = instance;
    return (
        <div
            style={{
                padding: '10px',
                border: '5px dotted rgba(164,164,164,0.42)'
            }}
        >
            <h3>
                <a href={instance.link}>{instance.name}</a>
            </h3>
            <br />
            Space: {space ? <SpaceLink space={space}>{space.title}</SpaceLink> : 'Not associated with a space'}
        </div>
    );
};

const AdminInstances: React.FC = () => {
    const [instances, setInstances] = useState([] as AdminInstanceEntry[]);

    React.useEffect(() => {
        getApi('/admin/instances').then(async (r) => setInstances(await r.json()));
    }, []);

    console.log(instances);

    return (
        <div>
            {instances
                .filter((i) => i.name[0] === 'x')
                .map((i) => (
                    <AdminInstanceEntry instance={i} key={i.name} />
                ))}
        </div>
    );
};

export default AdminInstances;
